import {SxProps} from '@mui/material';
import {Theme} from '@mui/material/styles';

import {orangeColors} from '../../../../../../../../../layouts/theme/designSystem';

export const adminsMultiSelectStyles = (theme: Theme): SxProps => ({
  '& .MuiOutlinedInput-root': {
    backgroundColor: 'white',
    color: theme.palette.text.primary,
    '&:hover': {
      backgroundColor: 'white',
    },
    '& fieldset': {
      borderColor: orangeColors[3],
    },
    '&:hover fieldset': {
      borderColor: orangeColors[100],
    },
    '&.Mui-focused fieldset': {
      borderColor: orangeColors[100],
    },
    '& .MuiOutlinedInput-input': {
      caretColor: theme.palette.text.primary,
    },
  },
});
